(() => {
  if (window.bedderPuffySizeFlow) return;
  window.bedderPuffySizeFlow = true;
  const normalize = (value) => {
    let size = String(value || '').toLowerCase().replace(/[–—-]/g, ' ').replace(/\s+/g, ' ').trim();
    if (/head.*split|split.*head/.test(size)) return size.includes('queen') ? 'head split queen' : size.includes('king') ? 'head split king' : size;
    if (size.includes('split') && /cal|california/.test(size)) return 'split cal king';
    if (size.includes('split') && size.includes('king')) return 'split king';
    if (/california|cal king/.test(size)) return 'cal king';
    if (/twin\s*(xl|long|extra)/.test(size)) return 'twin xl';
    return size.replace(/\s*\([^)]*\)/g, '').trim();
  };
  const matches = (listed, selected, handle) => {
    if (normalize(listed) === normalize(selected)) return true;
    return handle === 'puffy-deluxe-comforter' && listed.split('/').some((part) => normalize(part) === normalize(selected));
  };
  function refresh() {
    document.querySelectorAll('[data-puffy-size-flow]').forEach((guide) => {
      const labels = JSON.parse(guide.dataset.puffyLabels);
      const source = JSON.parse(guide.querySelector('[data-puffy-source]').textContent);
      const main = document.querySelector('product-info[id^="MainProduct-"]');
      const variantNode = main?.querySelector('variant-selects [data-selected-variant]');
      const selectedVariant = variantNode ? JSON.parse(variantNode.textContent) : null;
      const sourceSize = source.enabled ? (selectedVariant?.options?.[source.sizeIndex] || source.size) : '';
      const select = guide.querySelector('[data-puffy-compare-size]');
      if (sourceSize && guide.dataset.sourceSize !== sourceSize) {
        const option = Array.from(select.options).find((item) => normalize(item.value) === normalize(sourceSize));
        if (option) select.value = option.value;
        guide.dataset.sourceSize = sourceSize;
      }
      let previous = null;
      document.querySelectorAll('[data-puffy-size-link]').forEach((link) => {
        const isModel = link.classList.contains('pf-model');
        const selected = isModel ? select.value : sourceSize;
        if (!selected || (!isModel && !['puffy-signature-mattress-protector', 'puffy-signature-sheets-set', 'puffy-deluxe-mattress-topper', 'puffy-deluxe-mattress-pad', 'puffy-deluxe-comforter'].includes(link.dataset.puffyHandle))) return;
        const variants = JSON.parse(link.dataset.puffyVariants);
        const candidates = variants.filter((variant) => matches(variant.size, selected, link.dataset.puffyHandle));
        const chosen = candidates.find((variant) => variant.available) || candidates[0];
        const note = link.querySelector('[data-puffy-size-note]');
        const price = link.querySelector('[data-puffy-card-price]');
        const action = link.querySelector('.puffy-choose');
        if (action) action.textContent = `${chosen ? labels.chooseOptions : labels.checkFit} →`;
        link.classList.toggle('puffy-size-unavailable', !chosen || !chosen.available);
        if (chosen) {
          link.href = `${link.dataset.puffyUrl}?variant=${chosen.id}`;
          if (price) price.textContent = chosen.money;
          if (note) note.textContent = `${selected} · ${chosen.available ? labels.selected : labels.soldOut}`;
        } else {
          link.href = isModel ? link.dataset.puffyUrl : '/pages/customer-service#cs-cooling';
          if (price) price.textContent = labels.noMatch;
          if (note) note.textContent = `${selected} · ${isModel ? labels.otherSizes : labels.checkFit}`;
        }
        if (isModel) {
          const delta = link.querySelector('[data-puffy-price-difference]');
          if (delta) {
            delta.textContent = '';
            if (chosen && previous) {
              const difference = chosen.price - previous.price;
              const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: guide.dataset.currency }).format(Math.abs(difference) / 100);
              delta.textContent = `${labels.difference} ${previous.name}: ${difference < 0 ? '−' : '+'}${amount}`;
            }
          }
          previous = chosen ? { price: chosen.price, name: link.dataset.modelName } : null;
        }
      });
      guide.querySelectorAll('[data-puffy-pair]').forEach((link) => {
        const card = Array.from(guide.querySelectorAll('[data-puffy-size-link]')).find((item) => item.dataset.puffyHandle === link.dataset.puffyPair);
        if (card) link.href = card.href;
      });
    });
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-puffy-compare-size], product-info [name="id"]')) refresh();
  });
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
